(function () {
    function disabledEventPropagation(event) {
        if (event.stopPropagation) {
            event.stopPropagation();
        } else if (window.event) {
            window.event.cancelBubble = true;
        }
    }

    /**
     * Creates or shows the lightbox containing the specified feature.
     * @param page The name of the page calling this function (used only for Google Analytics purposes)
     * @param feature The name of the feature displayed in the lightbox. More specifically, a feature "foo"
     * that appears in the lightbox should be in an HTML element with an id of "lightboxfoo".
     */
    window.showLightbox = function (page, feature) {
        if (!document.getElementById('lightboxBackgroundOpacity')) {
            const lightboxBackgroundOpacity = document.createElement('div');
            lightboxBackgroundOpacity.id = 'lightboxBackgroundOpacity';
            $(lightboxBackgroundOpacity).on('click', function () {
                window.hideLightbox(page, feature);
            });
            document.body.appendChild(lightboxBackgroundOpacity);
        }
        if (!document.getElementById('lightboxContainer')) {
            const lightboxContainer = document.createElement('div');
            lightboxContainer.id = 'lightboxContainer';
            lightboxContainer.className = 'lightboxContainer';
            $(lightboxContainer).on('click', function () {
                window.hideLightbox(page, feature);
            });
            document.body.appendChild(lightboxContainer);
        }
        if (!document.getElementById('lightboxBackground')) {
            const lightboxBackground = document.createElement('div');
            lightboxBackground.id = 'lightboxBackground';
            lightboxBackground.className = 'lightboxBackground';
            document.getElementById('lightboxContainer').appendChild(lightboxBackground);
            $('#lightboxBackground').append($('#lightbox' + feature));
        }
        if (!document.getElementById('lightboxCloseButton')) {
            const lightboxCloseButton = document.createElement('div');
            lightboxCloseButton.id = 'lightboxCloseButton';
            lightboxCloseButton.className = 'lightboxCloseButton';
            lightboxCloseButton.innerHTML = '<a class="lightbox-close js-lightbox-close" aria-label="close overlay" href="#"><span role="link" aria-label="close modal" class="js-click-on-enter-or-space js-lightbox-close-span" tabindex="0"><svg class="icon icon-delete is-button"><use xlink:href="/images/icon/icon-junior.svg#icon-delete"></use></svg></span></a>';
            $('.js-lightbox-close').on('click', function (e) {
                window.hideLightbox(page, feature);
                e.preventDefault();
            });
            $('.js-lightbox-close-span').on('click', window.hideScreenAndOverlay);
            document.getElementById('lightboxBackground').appendChild(lightboxCloseButton);
        }
        // $("#lightboxBackground").html($("#lightboxBackground").html()+$('#lightbox'+feature).html());
        $('#lightbox' + feature).show();
        // document.getElementById("lightboxBackground").appendChild(document.getElementById("#lightbox"+feature));
        // document.getElementById("#lightbox"+feature).style.display = "";
        $('#lightboxBackgroundOpacity').height(window.getDocHeight());
        if (feature == 'TellAFriend') {
            $('.lightboxBackground').width('714px');
            $('.lightboxBackground').css('padding', '0').css('background', '#ededed');
            $('.ss-delete').css('color', '#ffffff');
        }
        $('.lightboxBackground').show();
        $('.lightboxContainer').css('position', 'absolute').css('top', $(document).scrollTop() + 50 + 'px');
        $('.lightboxContainer').fadeIn();
        trapFocus($('.overlay')[0]);
        $('#lightboxBackgroundOpacity').show();
        $(document).keyup(function (e) { if (e.keyCode == 27) { window.hideLightbox(page, feature); } });
        dcAnalytics.trackEventGA([page, feature, 'Open']);
    };

    // Called from close.html as well as other JS
    window.hideLightbox = function (page, feature) {
        if ($('#lightboxBackgroundOpacity').css('display') == 'block') {
            $('#lightboxBackgroundOpacity').fadeOut(500).promise().done(function () { $('#lightboxBackgroundOpacity').remove(); });
            $('.lightboxContainer').stop().fadeOut().promise().done(function () { $('.lightboxContainer').remove(); });
            dcAnalytics.trackEventGA([page, feature, 'Close']);
        }
    };

    // html lightbox
    // Called from meet_the_team.jsp and other JS
    window.showHTMLLightBox = function (htmlString) {
        if (!document.getElementById('lightboxBackgroundOpacity')) {
            const lightboxBackgroundOpacity = document.createElement('div');
            lightboxBackgroundOpacity.id = 'lightboxBackgroundOpacity';
            $(lightboxBackgroundOpacity).on('click', window.hideHTMLLightbox);
            document.body.appendChild(lightboxBackgroundOpacity);
        }
        if (!document.getElementById('lightboxContainer')) {
            const lightboxContainer = document.createElement('div');
            lightboxContainer.id = 'lightboxContainer';
            lightboxContainer.className = 'lightboxContainer';
            $(lightboxContainer).on('click', window.hideHTMLLightbox);
            document.body.appendChild(lightboxContainer);
        }
        if (!document.getElementById('lightboxBackground')) {
            const lightboxBackground = document.createElement('div');
            lightboxBackground.id = 'lightboxBackground';
            lightboxBackground.className = 'lightboxBackground';
            $(lightboxBackground).on('click', function (event) {
                disabledEventPropagation(event);
            });
            document.getElementById('lightboxContainer').appendChild(lightboxBackground);
        }
        if (!document.getElementById('lightboxCloseButton')) {
            const lightboxCloseButton = document.createElement('div');
            lightboxCloseButton.id = 'lightboxCloseButton';
            $(lightboxCloseButton).on('click', window.hideHTMLLightbox);
            document.getElementById('lightboxBackground').appendChild(lightboxCloseButton);
            $('#lightboxCloseButton').html('<svg class="icon icon-delete is-button lightboxCloseButton"><use xlink:href="/images/icon/icon-junior.svg#icon-delete"></use></svg>');
            $('#lightboxCloseButton').attr('tabindex', '0').attr('aria-label', 'close overlay');
        }
        if (!document.getElementById('lightboxHTML')) {
            const lightboxHtml = document.createElement('div');
            lightboxHtml.id = 'lightboxHTML';
            document.getElementById('lightboxBackground').appendChild(lightboxHtml);
        }
        $('#lightboxHTML').append(htmlString);

        $('#lightboxBackgroundOpacity').height(window.getDocHeight());
        $('#lightboxBackgroundOpacity').css('display', 'block');
        $('.lightboxBackground').css('width', 'auto');
        $('.lightboxBackground').show();
        $('.lightboxContainer').css('position', 'absolute').css('top', $(document).scrollTop() + 50 + 'px');
        $('.lightboxContainer').fadeIn();
        $(document).keyup(function (e) { if (e.keyCode == 27) { window.hideHTMLLightbox(); } });

        return window.returnFalse();
    };

    window.hideHTMLLightbox = function () {
        if (document.getElementById('lightboxBackgroundOpacity').style.display == 'block') {
            $('#lightboxBackgroundOpacity').fadeOut(500).promise().done(function () { $('#lightboxBackgroundOpacity').remove(); });
            $('#lightboxContainer').stop().fadeOut().promise().done(function () { $('#lightboxContainer').remove(); });
            $('body').trigger('triggeredHideHTMLLightbox');
        }
    };

    // video lightbox
    window.showVideoLightBox = function (theURL) {
        window.showVideoLightBoxWithClass(theURL, null);
    };

    // Apparently called by some articles in the DB
    window.showVideoLightBoxWithClass = function (theURL, className) {
        if (!document.getElementById('lightboxVideoBackgroundOpacity')) {
            const lightboxBackgroundOpacity = document.createElement('div');
            lightboxBackgroundOpacity.id = 'lightboxVideoBackgroundOpacity';
            lightboxBackgroundOpacity.addEventListener('click', hideVideoLightbox);
            document.body.appendChild(lightboxBackgroundOpacity);
        }
        if (!document.getElementById('lightboxVideoContainer')) {
            const lightboxVideoContainer = document.createElement('div');
            lightboxVideoContainer.id = 'lightboxVideoContainer';
            lightboxVideoContainer.addEventListener('click', hideVideoLightbox);
            document.body.appendChild(lightboxVideoContainer);
        }
        if (!document.getElementById('lightboxVideoBackground')) {
            const lightboxVideoBackground = document.createElement('div');
            lightboxVideoBackground.id = 'lightboxVideoBackground';
            if (className != null) lightboxVideoBackground.className = className;
            document.getElementById('lightboxVideoContainer').appendChild(lightboxVideoBackground);
        } else {
            if (className != null) document.getElementById('lightboxVideoBackground').className = className;
        }
        if (!document.getElementById('lightboxVideoCloseButton')) {
            const lightboxVideoCloseButton = document.createElement('div');
            lightboxVideoCloseButton.id = 'lightboxVideoCloseButton';
            lightboxVideoCloseButton.addEventListener('click', hideVideoLightbox);
            document.getElementById('lightboxVideoBackground').appendChild(lightboxVideoCloseButton);
        }
        if (!document.getElementById('lightboxVideo')) {
            const lightboxVideo = document.createElement('div');
            lightboxVideo.id = 'lightboxVideo';
            document.getElementById('lightboxVideoBackground').appendChild(lightboxVideo);
        }

        if (!document.getElementById('videoIframe')) {
            const videoIframe = document.createElement('iframe');
            videoIframe.id = 'videoIframe';
            videoIframe.setAttribute('name', 'videoIframe');
            videoIframe.setAttribute('frameborder', '0');
            videoIframe.setAttribute('allowtransparency', 'true');
            videoIframe.setAttribute('webkitAllowFullScreen', 'true');
            videoIframe.setAttribute('mozallowfullscreen', 'true');
            videoIframe.setAttribute('allowFullScreen', 'true');
            document.getElementById('lightboxVideo').appendChild(videoIframe);
        }
        if (className != null) document.getElementById('videoIframe').className = className;

        document.getElementById('videoIframe').src = theURL;
        document.getElementById('videoIframe').style.visibility = 'hidden';
        $('#lightboxVideoBackgroundOpacity').height(window.getDocHeight());
        $('#lightboxVideoBackground').show();
        $('#lightboxVideoContainer').css('position', 'absolute').css('top', $(document).scrollTop() + 50 + 'px');
        $('#lightboxVideoContainer').show();
        $('#lightboxVideoBackgroundOpacity').show();
        document.getElementById('videoIframe').onload = function () {
            document.getElementById('videoIframe').style.visibility = 'visible';
        };
        $(document).keyup(function (e) { if (e.keyCode == 27) { hideVideoLightbox(); } });
    };

    function hideVideoLightbox() {
        if (document.getElementById('lightboxVideoBackgroundOpacity').style.display == 'block') {
            $('#lightboxVideoBackgroundOpacity').fadeOut(500, function () {
                $('#lightboxVideoBackgroundOpacity').remove();
            });
            $('#lightboxVideoContainer').stop().hide('fast', function () {
                document.getElementById('lightboxVideoBackground').className = '';
                document.getElementById('videoIframe').className = '';
            });
            document.getElementById('videoIframe').src = '';
        }
    }

    // Called from adminfixworkflow.tag and other JS
    window.customConfirmWithCallback = function (text, data) {
        let ok = 'OK';
        let cancel = 'Cancel';
        if (data && data.hasOwnProperty('okText')) {
            ok = data.okText;
        }
        if (data && data.hasOwnProperty('cancelText')) {
            cancel = data.cancelText;
        }
        window.showHTMLLightBox('<div id="customConfirm"><p>' + text + '</p>' + '<div class="inline-button"><a class="button-primary js-click-on-enter-or-space" tabindex="0">' + ok + '</a><a class="button-secondary js-click-on-enter-or-space" tabindex="0">' + cancel + '</a></div></div>');
        $('#customConfirm .button-primary').on('click', function (e) {
            e.preventDefault();
            if (data && data.hasOwnProperty('callback')) data.callback();
            window.hideHTMLLightbox();
        });
        $('#customConfirm .button-secondary').on('click', function (e) {
            e.preventDefault();
            if (data && data.hasOwnProperty('cancelCallback')) data.cancelCallback();
            window.hideHTMLLightbox();
        });
        if (data && data.hideCancelButton) {
            $('#customConfirm').find('.button-secondary').hide();
        }
        return window.returnFalse();
    };

    window.toggleAndPositionScreenAndOverlayIframe = function (iframeId, iframeSrc, event) {
        window.toggleScreenAndOverlayIframe(iframeId, iframeSrc, event);
        $('#' + iframeId).closest('.overlay-iframe-wrapper').css('top', $(window).scrollTop() + 'px');
    };

    window.addToggleAndPositionScreenAndOverlayIframeCloseButton = function () {
        if ($('.js-overlay-close').length > 0) {
            $('.js-overlay-close').remove();
        }
        $('.overlay-iframe-wrapper').prepend('<div class="overlay-close on"><span role="link" aria-label="close modal" class="js-click-on-enter-or-space js-overlay-close close-icon-wrapper" tabindex="0"><svg class="icon icon-delete is-button"><use xlink:href="/images/icon/icon-junior.svg#icon-delete"></use></svg></span></div>');
        $('.js-overlay-close').on('click', window.hideScreenAndOverlay);
    };

    window.toggleScreenAndOverlayIframe = function (iframeId, iframeSrc, event) {
        window.clearTimeout(removeScreenAndOverlayTimer);
        removeScreenAndOverlayTimer = null;
        if (event) event.preventDefault ? event.preventDefault() : event.returnValue = false;
        if ($('#' + iframeId).length === 0) {
            $('body').prepend('<div class="overlay-iframe-wrapper"><iframe id="' + iframeId + '" class="overlay-iframe" frameborder="0" scrolling="no" src="' + iframeSrc + '"></iframe></div>');
        }
        $('#' + iframeId).on('load', function () {
            $(this).addClass('on');
            $('.overlay-iframe-wrapper,.js-overlay-close,.screen').addClass('on');
        });
        setTimeout(displayScreen, 250);
    };

    function displayScreen() {
        if ($('.screen').length === 0) {
            $('body').prepend('<div class="screen js-screen"></div>');
            $('.js-screen').on('click', window.hideScreenAndOverlay);
        }
        $('.screen').addClass('on');
    }

    // Called from other JS via parent.postMessage
    window.addPositionedOverlayIframeCloseButton = function () {
        if ($('.js-overlay-close').length > 0) {
            $('.js-overlay-close').remove();
        }
        $('.overlay').prepend('<div class="overlay-close on js-overlay-close"><span role="link" aria-label="close modal" class="js-click-on-enter-or-space close-icon-wrapper" tabindex="0"><svg class="icon icon-delete is-button"><use xlink:href="/images/icon/icon-junior.svg#icon-delete"></use></svg></span></div>');
        $('.js-overlay-close span').on('click', window.hideScreenAndOverlay);
    };

    window.showScreenAndOverlay = function (data) {
        if (data && data.message) {
            removeScreenAndOverlay();
            if ($('.screen').length === 0) {
                $('body').prepend('<div class="screen js-screen"></div>');
                // Allow close overlay on esc button
                $('body').on('keydown', function (e) {
                    if (e.which == 27) {
                        window.hideScreenAndOverlay();
                    }
                });
            }
            if ($('.overlay').length === 0) {
                $('body').prepend('<div class="overlay"><div class="overlay-close js-overlay-close"><span role="link" aria-label="close modal" class="js-click-on-enter-or-space js-overlay close-icon-wrapper" tabindex="0"><svg class="icon icon-delete is-button"><use xlink:href="/images/icon/icon-junior.svg#icon-delete"></use></svg></span></div></div>');
            }
            if (data.overlayClass) {
                $('.overlay').addClass(data.overlayClass);
            }
            if (data.overlayId) {
                $('.overlay').attr(data.overlayId);
            }
            $('.overlay').append(data.message);
            $('.screen,.overlay').addClass('on');
            trapFocus($('.overlay')[0]);
            $('.js-screen,.js-overlay,.js-screen-ok-button').on('click', function (e) {
                e.preventDefault();
                window.hideScreenAndOverlay();
            });
        }
    };

    function trapFocus(element) {
        const focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), span[role="link"], textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];
        const KEYCODE_TAB = 9;

        element.addEventListener('keydown', function (e) {
            const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    }

    // Called from lots of JS and JSP
    window.showScreenAndOverlayPopupErrors = function (data) {
        if (data.message && data.message.length > 0) {
            let errorsString = data.message;
            if (data.overrideCloseButton) {
                errorsString += data.overrideCloseButton;
            } else {
                errorsString += '<a class="button-primary screen-ok-button js-screen-ok-button" href="#"><span>OK</span></a>';
            }
            data.message = errorsString;
            window.showScreenAndOverlay(data);
        }
    };

    function removeScreenAndOverlay() {
        $('.screen,.overlay,.overlay-iframe,.js-overlay-close,.overlay-iframe-wrapper').remove();
        window.clearTimeout(removeScreenAndOverlayTimer);
        removeScreenAndOverlayTimer = null;
    }

    let removeScreenAndOverlayTimer = null;
    // Called from lots of JS and JSP
    window.hideScreenAndOverlay = function () {
        $('.screen,.overlay,.overlay-iframe,.js-overlay-close,.overlay-iframe-wrapper').removeClass('on');
        removeScreenAndOverlayTimer = setTimeout(removeScreenAndOverlay, 500);
        $('body').trigger('triggeredHideScreenAndOverlay');
    };

    // Called from lots of JS and JSP
    window.adjustOverlayHeight = function (data) {
        $(data.el).css('height', data.height + 'px');
    };
})();
